var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0 0,0 0,19.977 94.316,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.299 0,94.316 39.71,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.684 0,187.701 39.71,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,19.977 256,0 161.684,0 161.684,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.701 256,161.684 216.29,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.23 161.684,256 256,256 256,236.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.316 256,68.299 216.29,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.023 0,256 94.316,256 94.316,174.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.023 256,216.059 172.232,161.684 196.98,161.684 256,199.995 256,187.701    216.29,161.684 256,161.684 256,148.21 148.211,148.21 148.211,256 161.684,256 161.684,174.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.21 0,161.684 39.71,161.684 0,187.701 0,206.602 69.197,161.684 93.945,161.684    0,222.666 0,236.023 94.316,174.23 94.316,256 107.789,256 107.789,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0 94.316,0 94.316,81.77 0,19.977 0,41.839 80.842,94.316 56.094,94.316 0,57.904    0,68.299 39.71,94.316 0,94.316 0,107.79 107.789,107.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.79 256,94.316 216.29,94.316 256,68.299 256,49.157 186.432,94.316 161.684,94.316    256,33.093 256,19.977 161.684,81.77 161.684,0 148.211,0 148.211,107.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.21 256,107.79 148.211,107.79 148.211,0 107.789,0 107.789,107.79 0,107.79    0,148.21 107.789,148.21 107.789,256 148.211,256 148.211,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.684 0,206.602 0,222.666 93.945,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.684 256,216.059 256,199.995 196.98,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.316 0,41.839 0,57.904 56.094,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.316 256,49.157 256,33.093 161.684,94.316  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E67346"
    },
    d: "M330.247,453.306l-4.484-10.465l2.242,5.232l-2.268-5.219c0.945-0.417,23.138-10.542,23.138-40.315  h11.384C360.258,440.012,331.473,452.78,330.247,453.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB7D4B"
    },
    d: "M334.697,427.849l-8.048-8.048c15.387-15.387,23.384-19.608,24.246-20.04l5.091,10.183l-2.546-5.091  l2.59,5.069C355.958,409.958,348.75,413.795,334.697,427.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E67346"
    },
    d: "M447.22,453.306l4.484-10.465l-2.242,5.232l2.268-5.219c-0.945-0.417-23.138-10.542-23.138-40.315  h-11.384C417.209,440.012,445.994,452.78,447.22,453.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB7D4B"
    },
    d: "M442.77,427.849l8.049-8.048c-15.387-15.387-23.384-19.608-24.246-20.04l-5.091,10.183l2.546-5.091  l-2.59,5.069C421.509,409.958,428.716,413.795,442.77,427.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M388.717,254.554h-60.712c0,0,0,72.096,0,91.068s3.794,68.301,60.712,87.274  c56.918-18.973,60.712-68.301,60.712-87.274s0-91.068,0-91.068L388.717,254.554L388.717,254.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8C8C8"
    },
    d: "M415.278,277.321h-32.621c-3.447,0-6.79-1.173-9.482-3.326l-12.736-10.189  c-1.346-1.076-3.018-1.663-4.741-1.663h-1.133c-4.191,0-7.589,3.398-7.589,7.589h-5.692c-3.143,0-5.692,2.548-5.692,5.692  c0,3.143,2.548,5.692,5.692,5.692h5.692c2.096,0,3.794,1.699,3.794,3.795v18.973c0,7.064,4.849,12.949,11.384,14.641v11.92h7.589  l2.846-11.384h35.099l3.795,3.795v7.589h3.794v-11.384h3.795v11.384h3.794v-12.436c2.259-1.315,3.794-3.735,3.794-6.536v-22.767  C426.662,282.418,421.565,277.321,415.278,277.321z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "346.977,326.65 354.566,349.417 422.867,349.417 430.456,326.65 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M429.144,341.828c-10.116,0-10.116,7.589-20.232,7.589c-10.114,0-10.114-7.589-20.227-7.589  c-10.112,0-10.112,7.589-20.225,7.589c-10.115,0-10.115-7.589-20.231-7.589c-10.094,0-10.119,7.554-20.17,7.586  c0.122,4.227,0.484,9.397,1.417,15.11c8.649-0.707,9.161-7.518,18.752-7.518c10.115,0,10.115,7.589,20.231,7.589  c10.112,0,10.112-7.589,20.225-7.589c10.114,0,10.114,7.589,20.227,7.589c10.116,0,10.116-7.589,20.232-7.589  c9.618,0,10.123,6.825,18.814,7.52c0.933-5.713,1.296-10.883,1.418-15.11C439.278,349.397,439.264,341.828,429.144,341.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M429.144,357.006c-10.116,0-10.116,7.589-20.232,7.589c-10.114,0-10.114-7.589-20.227-7.589  c-10.112,0-10.112,7.589-20.225,7.589c-10.115,0-10.115-7.589-20.231-7.589c-9.591,0-10.103,6.812-18.752,7.518  c0.743,4.547,1.858,9.439,3.49,14.466c5.534-1.933,7.151-6.806,15.262-6.806c10.115,0,10.115,7.589,20.231,7.589  c10.112,0,10.112-7.589,20.225-7.589c10.114,0,10.114,7.589,20.227,7.589c10.116,0,10.116-7.589,20.232-7.589  c8.141,0,9.75,4.893,15.32,6.818c1.634-5.031,2.75-9.926,3.494-14.477C439.267,363.831,438.762,357.006,429.144,357.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M429.144,372.184c-10.116,0-10.116,7.589-20.232,7.589c-10.114,0-10.114-7.589-20.227-7.589  c-10.112,0-10.112,7.589-20.225,7.589c-10.115,0-10.115-7.589-20.231-7.589c-8.111,0-9.727,4.873-15.262,6.806  c1.309,4.031,2.965,8.145,5.037,12.247c2.566-1.924,5.094-3.876,10.224-3.876c10.115,0,10.115,7.589,20.231,7.589  c10.112,0,10.112-7.589,20.225-7.589c10.114,0,10.114,7.589,20.227,7.589c10.116,0,10.116-7.589,20.232-7.589  c5.16,0,7.693,1.968,10.274,3.9c2.076-4.106,3.735-8.225,5.046-12.259C438.894,377.077,437.285,372.184,429.144,372.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M429.144,387.362c-10.116,0-10.116,7.589-20.232,7.589c-10.114,0-10.114-7.589-20.227-7.589  c-10.112,0-10.112,7.589-20.225,7.589c-10.115,0-10.115-7.589-20.231-7.589c-5.13,0-7.659,1.952-10.224,3.876  c1.975,3.908,4.336,7.797,7.157,11.584c0.917-0.173,1.92-0.282,3.068-0.282c10.115,0,10.115,7.589,20.231,7.589  c10.112,0,10.112-7.589,20.225-7.589c10.114,0,10.114,7.589,20.227,7.589c10.116,0,10.116-7.589,20.232-7.589  c1.17,0,2.193,0.11,3.123,0.289c2.817-3.781,5.177-7.665,7.151-11.568C436.837,389.33,434.304,387.362,429.144,387.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M432.267,402.829c-0.931-0.179-1.954-0.289-3.123-0.289c-10.116,0-10.116,7.589-20.232,7.589  c-10.114,0-10.114-7.589-20.227-7.589c-10.112,0-10.112,7.589-20.225,7.589c-10.115,0-10.115-7.589-20.231-7.589  c-1.148,0-2.151,0.108-3.068,0.282c6.15,8.256,14.492,15.996,25.782,22.293c7.687-1.135,8.542-7.397,17.741-7.397  c9.22,0,10.058,6.29,17.793,7.404C417.77,418.825,426.115,411.085,432.267,402.829z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 386.82,
    y: 341.83,
    style: {
      fill: "#FF965A"
    },
    width: 3.795,
    height: 64.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.33,
    y: 351.31,
    style: {
      fill: "#FF965A"
    },
    width: 22.767,
    height: 3.795
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.33,
    y: 374.08,
    style: {
      fill: "#FF965A"
    },
    width: 22.767,
    height: 3.795
  })), /*#__PURE__*/React.createElement("rect", {
    x: 377.33,
    y: 355.1,
    style: {
      fill: "#FFE15A"
    },
    width: 22.767,
    height: 15.01
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "386.82,341.828 386.82,349.417 375.436,345.622 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.12,
    y: 341.83,
    style: {
      fill: "#FF965A"
    },
    width: 3.795,
    height: 44.585
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.63,
    y: 351.31,
    style: {
      fill: "#FF965A"
    },
    width: 22.767,
    height: 3.795
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.63,
    y: 374.08,
    style: {
      fill: "#FF965A"
    },
    width: 22.767,
    height: 3.795
  })), /*#__PURE__*/React.createElement("rect", {
    x: 402.63,
    y: 355.1,
    style: {
      fill: "#FFE15A"
    },
    width: 22.767,
    height: 15.01
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "412.116,341.828 412.116,349.417 400.733,345.622 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 361.37,
    y: 341.83,
    style: {
      fill: "#FF965A"
    },
    width: 3.795,
    height: 44.27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.88,
    y: 351.31,
    style: {
      fill: "#FF965A"
    },
    width: 22.767,
    height: 3.795
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.88,
    y: 374.08,
    style: {
      fill: "#FF965A"
    },
    width: 22.767,
    height: 3.795
  })), /*#__PURE__*/React.createElement("rect", {
    x: 351.88,
    y: 355.1,
    style: {
      fill: "#FFE15A"
    },
    width: 22.767,
    height: 15.01
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "361.365,341.828 361.365,349.417 349.981,345.622 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF965A"
    },
    d: "M407.689,383.567c0,10.461-8.512,18.973-18.973,18.973s-18.973-8.512-18.973-18.973h-3.794h-3.764  l-25.699-5.803l-0.837,3.702l11.328,2.558v3.338l8.351,3.341c3.292,15.415,17.006,27.016,33.388,27.016  c16.219,0,29.807-11.377,33.271-26.562h12.263v-11.384L407.689,383.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M449.429,254.554c0,0,0,72.096,0,91.068s-3.795,68.301-60.712,87.274  c-56.918-18.973-60.712-68.301-60.712-87.274s0-91.068,0-91.068h60.712L449.429,254.554 M453.224,250.759h-3.794h-60.712h-60.712  h-3.794v3.795v91.068c0,44.993,22.483,77.265,63.307,90.873l1.2,0.4l1.2-0.4c40.824-13.608,63.307-45.881,63.307-90.873v-91.068  v-3.795L453.224,250.759L453.224,250.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF965A"
    },
    d: "M388.717,451.868c-27.929,0-53.829-9.357-69.283-25.027l10.805-10.657  c12.664,12.84,34.525,20.507,58.478,20.507s45.814-7.667,58.478-20.507L458,426.841  C442.546,442.512,416.646,451.868,388.717,451.868z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFk);
export default __webpack_public_path__ + "static/media/FK.983ead1226e7b8cbfffe5a31dae681a5.svg";
export { ForwardRef as ReactComponent };